import React from 'react';
import { XCircle, Clock, Zap, ZapOff, Archive, Check, HelpCircle, Inbox } from 'lucide-react';
import './StatusBadge.css';

const createConfig = (overrides = {}) => {
    const baseColors = {
        background: 'linear-gradient(135deg, #e2e8f0 0%, #f1f5f9 100%)',
        text: '#0f172a',
        border: 'rgba(148, 163, 184, 0.45)',
        shadow: '0 6px 16px rgba(15, 23, 42, 0.08)',
        hoverShadow: '0 10px 24px rgba(15, 23, 42, 0.12)',
    };

    const merged = {
        icon: <HelpCircle size={16} />,
        text: 'Desconocido',
        className: 'unknown',
        colors: baseColors,
        ...overrides,
    };

    merged.colors = {
        ...baseColors,
        ...(overrides.colors || {}),
    };

    return merged;
};

const statusConfig = {
    pendiente: createConfig({
        icon: <Clock size={16} />,
        text: 'Pendiente',
        className: 'pending',
        colors: {
            background: 'linear-gradient(135deg, #fff7ed 0%, #fffbeb 100%)',
            text: '#b45309',
            border: 'rgba(251, 191, 36, 0.4)',
            shadow: '0 6px 16px rgba(217, 119, 6, 0.18)',
            hoverShadow: '0 12px 24px rgba(180, 83, 9, 0.25)',
        },
    }),
    activo: createConfig({
        icon: <Zap size={16} />,
        text: 'Activo',
        className: 'active',
        colors: {
            background: 'linear-gradient(135deg, #ecfdf5 0%, #dcfce7 100%)',
            text: '#047857',
            border: 'rgba(16, 185, 129, 0.4)',
            shadow: '0 6px 16px rgba(16, 185, 129, 0.18)',
            hoverShadow: '0 12px 24px rgba(5, 150, 105, 0.25)',
        },
    }),
    completado: createConfig({
        icon: <Check size={16} />,
        text: 'Completado',
        className: 'completed',
        colors: {
            background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
            text: '#3730a3',
            border: 'rgba(99, 102, 241, 0.4)',
            shadow: '0 6px 16px rgba(79, 70, 229, 0.18)',
            hoverShadow: '0 12px 24px rgba(79, 70, 229, 0.25)',
        },
    }),
    cancelado: createConfig({
        icon: <Archive size={16} />,
        text: 'Cancelado',
        className: 'cancelled',
        colors: {
            background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
            text: '#374151',
            border: 'rgba(107, 114, 128, 0.35)',
            shadow: '0 6px 16px rgba(107, 114, 128, 0.16)',
            hoverShadow: '0 12px 24px rgba(55, 65, 81, 0.22)',
        },
    }),
    rechazado: createConfig({
        icon: <XCircle size={16} />,
        text: 'Rechazado',
        className: 'rejected',
        colors: {
            background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
            text: '#b91c1c',
            border: 'rgba(248, 113, 113, 0.45)',
            shadow: '0 6px 16px rgba(239, 68, 68, 0.18)',
            hoverShadow: '0 12px 24px rgba(220, 38, 38, 0.25)',
        },
    }),
    desconocido: createConfig(),
};

statusConfig.aprobado = { ...statusConfig.activo, text: 'Aprobado' };
statusConfig.acelerador_desactivado = createConfig({
    icon: <ZapOff size={16} />,
    text: 'Acelerador Pausado',
    className: 'paused',
    colors: {
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        text: '#92400e',
        border: 'rgba(217, 119, 6, 0.4)',
        shadow: '0 6px 16px rgba(217, 119, 6, 0.18)',
        hoverShadow: '0 12px 24px rgba(180, 83, 9, 0.25)',
    },
});

statusConfig.abierto = createConfig({
    icon: <Inbox size={16} />,
    text: 'Abierto',
    className: 'open',
    colors: {
        background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
        text: '#0369a1',
        border: 'rgba(59, 130, 246, 0.35)',
        shadow: '0 6px 16px rgba(59, 130, 246, 0.18)',
        hoverShadow: '0 12px 24px rgba(3, 105, 161, 0.25)',
    },
});

statusConfig.en_progreso = createConfig({
    icon: <Clock size={16} />,
    text: 'En progreso',
    className: 'in-progress',
    colors: {
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        text: '#92400e',
        border: 'rgba(217, 119, 6, 0.4)',
        shadow: '0 6px 16px rgba(217, 119, 6, 0.18)',
        hoverShadow: '0 12px 24px rgba(180, 83, 9, 0.25)',
    },
});

statusConfig.respondido = createConfig({
    icon: <Check size={16} />,
    text: 'Respondido',
    className: 'answered',
    colors: {
        background: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
        text: '#5b21b6',
        border: 'rgba(99, 102, 241, 0.4)',
        shadow: '0 6px 16px rgba(99, 102, 241, 0.18)',
        hoverShadow: '0 12px 24px rgba(76, 29, 149, 0.25)',
    },
});

statusConfig.cerrado = createConfig({
    icon: <Archive size={16} />,
    text: 'Cerrado',
    className: 'closed',
    colors: {
        background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
        text: '#1f2937',
        border: 'rgba(148, 163, 184, 0.45)',
        shadow: '0 6px 16px rgba(15, 23, 42, 0.12)',
        hoverShadow: '0 12px 24px rgba(15, 23, 42, 0.18)',
    },
});

const normalizeStatusKey = (rawStatus) => {
    if (!rawStatus) return 'desconocido';
    return String(rawStatus)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '_');
};

const StatusBadge = ({ status, variant = 'default' }) => {
    const safeStatus = normalizeStatusKey(status);
    const config = statusConfig[safeStatus] || statusConfig.desconocido;

    const classNames = ['status-badge'];
    if (config.icon) {
        classNames.push('icon-badge');
    }
    if (variant) {
        classNames.push(`badge-${variant}`);
    }
    if (config.className) {
        classNames.push(`status-${config.className}`);
    }

    const styleVars = {};
    if (variant === 'table' && config.colors) {
        styleVars['--badge-bg'] = config.colors.background;
        styleVars['--badge-text'] = config.colors.text;
        styleVars['--badge-border'] = config.colors.border;
        styleVars['--badge-shadow'] = config.colors.shadow;
        styleVars['--badge-hover-shadow'] = config.colors.hoverShadow;
    }

    return (
        <span className={classNames.join(' ')} data-status={safeStatus} style={styleVars}>
            {config.icon}
            <span className="status-badge__label">{config.text}</span>
        </span>
    );
};

export default StatusBadge;